import createPostInstance from './post-json';

const TIMEOUT_MS = 5000;

export default (url, payload, timeout = TIMEOUT_MS) => {
    const post = createPostInstance(window.XMLHttpRequest);
    post(url, timeout, payload);
};
